"use client";

/**
 * i18n Provider — initializes react-i18next on mount.
 *
 * Wrap in root layout to make useTranslation() available everywhere.
 * Loads the stored language preference from localStorage.
 */

import { useEffect, useState, type ReactNode } from "react";
import { I18nextProvider } from "react-i18next";
import i18n, { initI18n } from "@/lib/integrations/i18n";

export function I18nProvider({ children }: { children: ReactNode }) {
  const [, setReady] = useState(false);

  useEffect(() => {
    let active = true;

    initI18n().then(() => {
      if (active) setReady(true);
    });

    return () => {
      active = false;
    };
  }, []);

  // Always wrap in I18nextProvider — even before translations load.
  // This ensures useTranslation() hooks never throw. Translation keys
  // render as-is until resources hydrate, which is better than crashing.
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
